import { Component, Input } from '@angular/core';
import { TermsLinks } from 'src/app/components/auth/models/interface/termsLinks.interface';
import { environment } from 'src/environments/environment';
import { MuUserService } from '../../../sharedProtos/user/mu-user.service';
import { UserType } from 'src/app/components/shared/models/interface/userType.enum';
import { TermsType } from 'src/app/components/shared/api/ph-web/user/user.api_pb';
import { MuComponent } from '../../../types/MuComponent.componetent';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginCredentials } from 'src/app/components/auth/models/interface/loginCredentials.interface';
import { FormControlValidatorService } from '../../../sharedServices/form-control-validator.service';
import { AuthLoginFlag } from '../models/auth-login.flags.enum';
import { Flags } from '../../../types/flags.type';
import { TranslateService } from '@ngx-translate/core';
import { MuException } from '../../../types/exception.type';
import { RoleType } from '../../../models/interface/roleType.enum';
import { PermissionMenuService } from '../../permission/permission-menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataService } from '../../../sharedServices/user-data.service';
import { OauthResponse } from 'src/app/components/auth/models/interface/oauthResponse.interface';
import { MuCookieService } from '../../../sharedServices/mu-cookie.service';
import { UserData } from '../models/userData.interface';
import { PermissionService } from '../../permission/permission.service';
import { MuLayoutService } from '../../../sharedProtos/layout/mu-layout.service';
import { CountryShared } from '../../../models/interface/country.interface';
import { MuDeliveryService } from '../../../sharedProtos/delivery/mu-delivery.service';
import { UtilsService } from '../../../sharedServices/utils.service';
import { authConstants } from 'src/app/components/auth/auth.constants';
import { StorageService } from '../../../sharedServices/storage.service';
import { StorageClassifier } from '../../../models/interface/storageClassifier.enum';
import { muOldPlatformWeb } from 'src/environments/constants';
import { MuCryptService } from '../../../sharedServices/mu-crypt.service';
import { Actions } from '../../../types/actions.type';
import { LoginSharedActions } from './login-shared-actions';
import { sharedAuthConstants } from '../../../sharedConstants/auth.constants';

@Component({
  selector: 'app-login-shared',
  templateUrl: './login-shared.component.html',
  styleUrls: ['./login-shared.component.sass'],
})
export class LoginSharedComponent extends MuComponent {
  @Input() actionList: Actions<LoginSharedActions, any>;

  termsLinks: TermsLinks;
  loginForm: UntypedFormGroup;
  isRememberChecked: boolean;
  flagList: Flags<AuthLoginFlag> = new Flags<AuthLoginFlag>();
  authConstants = authConstants;
  oauthResponse: OauthResponse;
  countryId: number;
  userData: UserData;
  countryList: CountryShared[];

  constructor(
    private layoutService: MuLayoutService,
    private muCookieService: MuCookieService,
    private translateService: TranslateService,
    private muUserService: MuUserService,
    private formBuilder: UntypedFormBuilder,
    private utilsService: UtilsService,
    private permissionService: PermissionService,
    private validator: FormControlValidatorService,
    private router: Router,
    private route: ActivatedRoute,
    private muCryptService: MuCryptService<any>,
    private per: PermissionMenuService,
    private storageService: StorageService,
    private muDeliveryService: MuDeliveryService,
    private userDataService: UserDataService
  ) {
    super();
    this.countryList = environment.countries;
  }

  async muOnInit(): Promise<void> {
    this.route.params.subscribe(params => {
      let credentials: LoginCredentials = { email: '', password: '' };
      if (params.credentials) {
        try {
          credentials = this.muCryptService.decrypt(params.credentials, true);
          this.storageService.setValue(StorageClassifier.TEMPORAL, muOldPlatformWeb.oldUserPlatform, 'yes');
        } catch (e: any) {}
      }
      this.initData(credentials);
    });
    await this.utilsService.muSleep(500);

    this.router.url === sharedAuthConstants.url.login ? await this.getTermsLink() : '';
  }

  muOnDestroy(): void {
    /** */
  }

  /**
   * init data
   * @param {LoginCredentials} credentials
   */
  initData(credentials?: LoginCredentials): void {
    this.buildForm(credentials);
    const refPhone = localStorage.getItem(authConstants.storagePhone);
    this.countryId = parseInt(refPhone === null ? '1' : JSON.parse(refPhone).country, 10);

    this.watch(this.flagList.valueChanges(AuthLoginFlag.ACTION_TERMS_MODAL)).subscribe(async () => {
      await this.updateTerms();
    });

    if (credentials.email && credentials.password) {
      this.signIn(credentials, true);
    }
  }

  /**
   * build form
   * @param {LoginCredentials} credentials
   */
  buildForm(credentials: LoginCredentials): void {
    const email = credentials?.email || localStorage.getItem('mu-auth-email');
    const password = credentials?.password;
    this.isRememberChecked = email !== null;

    this.loginForm = this.formBuilder.group({
      isInvalidForm: false,
      email: [email || '', [Validators.required, this.validator.isValidEmail()]],
      password: [password || '', Validators.required],
      remember: [],
    });
  }

  /**
   * get terms links
   */
  async getTermsLink(): Promise<void> {
    try {
      const geoName: string = localStorage.getItem('location')?.toString() || navigator.language.split('-')[1];
      const countryId: number = (environment.countries.find(x => x.geoName === geoName) || environment.countries[0]).id;
      this.termsLinks = {
        terms: await this.muUserService.getTermsOrPolitics(countryId, UserType.PERSON, TermsType.TERMS_AND_CONDITIONS),
        politics: await this.muUserService.getTermsOrPolitics(countryId, UserType.PERSON, TermsType.DATA_PRIVACY_POLICY),
      };
    } catch (e) {}
  }

  /**
   * sign in
   * @param {LoginCredentials} loginCredentials
   * @param {boolean} autoSignIn
   * @param {boolean} fromRegister
   */
  async signIn(loginCredentials: LoginCredentials, autoSignIn?: boolean, fromRegister?: boolean): Promise<void> {
    this.checkForm(autoSignIn);
    if (autoSignIn || this.loginForm.valid) {
      try {
        this.flagList.enable(AuthLoginFlag.LOADING);
        this.oauthResponse = await this.muDeliveryService.getOauthData(loginCredentials);
        this.setCookies();
        this.cleanUserData(await this.muDeliveryService.getUserData(this.oauthResponse.accessToken));
        this.validateUserData(fromRegister);
      } catch (error: any | MuException) {
        this.flagList.disable(AuthLoginFlag.LOADING);
        this.checkForm(autoSignIn, true);
      }
    }
  }

  /**
   * clean user data
   * @param {UserData} userData
   */
  cleanUserData(userData: UserData): void {
    this.userData = {
      ...this.cleanUserDataBlockOne(userData),
      ...this.cleanUserDataBlockTwo(userData),
    };
  }

  /**
   * clean first block of user data
   * @param {UserData} userData
   * @returns {UserData} response
   */
  cleanUserDataBlockOne(userData: UserData): UserData {
    return {
      ...userData,
      cityId: userData.cityId || 0,
      userPhone: userData.userPhone || '',
      companyId: userData.companyId || '',
      identification: userData.identification || '',
      companyName: userData.companyName?.replace(/[^a-z\d\s]+/gi, '') || '',
    };
  }

  /**
   * claen second block of user data
   * @param {UserData} userData
   * @returns {UserData} response
   */
  cleanUserDataBlockTwo(userData: UserData): UserData {
    return {
      ...userData,
      name: userData.name?.replace(/[^a-z\d\s]+/gi, '') || '',
      cityName: userData.cityName || '',
      servicesAmount: userData.servicesAmount || 0,
      usersAmount: userData.usersAmount || 0,
      roleNameList: userData.roleNameList || [],
      roleIdList: userData.roleIdList || [],
      status: userData.status || 0,
      statusUser: userData.statusUser || 0,
      terms: userData.terms === null ? false : userData.terms,
      timeEnd: userData.timeEnd || 0,
    };
  }

  /**
   * set cookies on success oauth
   */
  setCookies(): void {
    this.muCookieService.setCookie('token-expires-in', this.oauthResponse.expiresIn.toString(), this.oauthResponse.expiresIn);
    this.muCookieService.setCookie('token-refresh-token', this.oauthResponse.refreshToken, this.oauthResponse.expiresIn);
    this.muCookieService.setCookie('token-token-type', this.oauthResponse.tokenType, this.oauthResponse.expiresIn);
  }

  /**
   * validate user data from api
   */
  async validateUserData(fromRegister?: boolean): Promise<void> {
    if (!(await this.areTermsAccepted(fromRegister))) {
      this.flagList.enable(AuthLoginFlag.SHOW_TERMS_MODAL);
      return environment.guardClause;
    }
    const country = this.countryList.find(x => x.id === this.userData.countryId);
    !this.userData.countryId || !country || !country.geoName
      ? localStorage.removeItem('location')
      : this.layoutService.changeCountryValue(country.geoName);
    !this.isRememberChecked ? localStorage.removeItem('mu-auth-email') : localStorage.setItem('mu-auth-email', this.userData.email);
    this.setUserDataAndRedirect();
  }

  /**
   * check if terms are accepted
   * @returns {boolean} response
   */
  async areTermsAccepted(fromRegister?: boolean): Promise<boolean> {
    if (fromRegister) {
      await this.updateTerms();
      return true;
    }
    return this.muUserService.checkTermsAndPolitics(parseInt(this.userData.id, 10), [
      TermsType.TERMS_AND_CONDITIONS,
      TermsType.DATA_PRIVACY_POLICY,
    ]);
  }

  /**
   * update terms
   */
  async updateTerms(): Promise<void> {
    await this.muUserService.acceptOrUpdateTerms(parseInt(this.userData.id, 10), true);
    this.setUserDataAndRedirect();
  }

  /**
   * set remember event
   */
  changeRemember(): void {
    this.isRememberChecked = !this.isRememberChecked;
  }

  /**
   * change input type password
   * @param {Event} event
   * @param {string} id
   */
  changeInputType(event: Event, id: string): void {
    this.utilsService.changeInputTypePassword(event, id);
  }

  /**
   * set user data and redirect
   */
  async setUserDataAndRedirect(): Promise<void> {
    this.userDataService.setUserData(this.userData);
    const encodeData = window.btoa(JSON.stringify(JSON.stringify(this.userData)));
    this.muCookieService.setCookie('mu-data', encodeData, this.oauthResponse.expiresIn);
    localStorage.setItem('mu-data', encodeData);

    this.permissionService.reset();
    await this.permissionService.getPermissionList({ userData: this.userData });

    if (
      localStorage.getItem('location') === 'MX' &&
      (Object.values(this.userData.roleIdList || {}).includes(RoleType.PLUS_ADMIN) ||
        Object.values(this.userData.roleIdList || {}).includes(RoleType.BASIC_ADMIN))
    ) {
      localStorage.setItem('_r_x_a', window.btoa(JSON.stringify(this.userData.roleIdList)));
    }

    this.muCookieService.setCookie('token-mu', this.oauthResponse.accessToken, this.oauthResponse.expiresIn);
    this.userDataService.setTokenLocal(this.oauthResponse.accessToken);

    const redirectLink = await this.per.getRedirectByPermission();

    const routers = {
      '/co/ext/cotizar-servicio': true,
      '/co/ext/mercancia': true,
      '/mx/ext/cotizar-servicio': true,
      '/mx/ext/mercancia': true,
    };

    if (routers[this.router.url]) {
      window.setTimeout(() => {
        location.reload();
      }, 500);

      this.router.navigate(['/express/solicitud-de-servicio']);
      return environment.guardClause;
    }

    this.router.navigate([redirectLink]);
  }

  /**
   * check if is valid form
   * @param {boolean} autoSignIn
   * @param {boolean} forceError
   */
  checkForm(autoSignIn?: boolean, forceError?: boolean): void {
    if (autoSignIn) {
      return environment.guardClause;
    }
    const refLogin: HTMLElement = document.getElementById('mu-auth-login');
    const element = refLogin.getElementsByClassName('error')[0];
    if (element) {
      element.innerHTML =
        this.loginForm.get('email').invalid || this.loginForm.get('password').invalid || forceError
          ? this.translateService.instant('form.error.invalid.credentials')
          : '';
    }
  }
}
